import { render, staticRenderFns } from "./hotSaleCourse.vue?vue&type=template&id=32b6da68&scoped=true&"
import script from "./hotSaleCourse.vue?vue&type=script&lang=js&"
export * from "./hotSaleCourse.vue?vue&type=script&lang=js&"
import style0 from "./hotSaleCourse.vue?vue&type=style&index=0&id=32b6da68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b6da68",
  null
  
)

export default component.exports